var map = {
	"./arrow.svg": 115,
	"./ask.svg": 121,
	"./close.svg": 122,
	"./curetime.svg": 123,
	"./files.svg": 124,
	"./gallery.svg": 130,
	"./heart.svg": 131,
	"./link.svg": 132,
	"./maketime.svg": 133,
	"./material.svg": 134,
	"./project.svg": 125,
	"./recipe.svg": 135,
	"./technique.svg": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;